"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuoteLabel = exports.QuoteLabelProvider = void 0;
var react_1 = require("react");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var quoteLabelContext = (0, react_1.createContext)(undefined);
exports.QuoteLabelProvider = quoteLabelContext.Provider;
var useQuoteLabel = function () {
    var context = (0, react_1.useContext)(quoteLabelContext);
    (0, tiny_invariant_1.default)(context, "useQuoteLabel must be used inside QuoteLabelProvider");
    return context;
};
exports.useQuoteLabel = useQuoteLabel;
